/**
 * Click Outside Directive
 * - 영역 외부를 클릭시 이벤트가 발생
 *
 * @since: 2023-03-30
 * @author: jungmin87.kim
 */

const HANDLER = '_vue_click_outside'
function bind (el, binding, vnode) {
  unbind(el, binding)

  const vm = vnode.context

  const callback = binding.value
  let initialMacrotaskEnded = false
  setTimeout(() => {
    initialMacrotaskEnded = true
  }, 0)
  el[HANDLER] = (ev) => {
    const path = ev.path || (ev.composedPath ? ev.composedPath() : undefined)
    if (initialMacrotaskEnded && (path ? path.indexOf(el) < 0 : !el.contains(ev.target))) {
      return callback.call(vm, ev)
    }
  }

  if (binding.arg) {
    document.documentElement.addEventListener(binding.arg, el[HANDLER], false)
  } else {
    document.documentElement.addEventListener('mousedown', el[HANDLER], false)
  }
}

function unbind (el, binding) {
  if (binding.arg) {
    document.documentElement.removeEventListener(binding.arg, el[HANDLER], false)
  } else {
    document.documentElement.removeEventListener('mousedown', el[HANDLER], false)
  }

  delete el[HANDLER]
}
export default {
  name: 'click-outside',
  bind: bind,
  update (el, binding, vnode) {
    if (binding.value === binding.oldValue) return
    this.bind(el, binding, vnode)
  },
  unbind: unbind
}
